import Immutable from 'immutable'

export default function wrap(nodes) {
  return Immutable.fromJS([{ id: '__root', children: nodes }])
}
